// GA4 analytics — privacy-first, consent-gated.
//
// The gtag.js snippet is loaded ONLY after the visitor clicks "Accept" on
// the cookie banner (or if they already accepted on a previous visit).
// If they reject (or if REACT_APP_GA4_MEASUREMENT_ID isn't set), every
// function below is a silent no-op.

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";
const CONSENT_KEY = "ttl_cookie_choice";

let scriptLoaded = false;

function hasConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY) === "accepted";
  } catch {
    return false;
  }
}

function isEnabled() {
  return Boolean(GA_ID) && hasConsent();
}

function loadScriptOnce() {
  if (scriptLoaded || typeof window === "undefined") return;
  scriptLoaded = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  // anonymize_ip aligns with GA4's default EU behavior; ad_storage denied
  // keeps us firmly on the "functional analytics only" side of consent law.
  gtag("config", GA_ID, {
    anonymize_ip: true,
    send_page_view: false, // we fire pageviews manually on SPA route changes
  });
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "granted",
  });
}

export function initAnalyticsIfConsented() {
  if (isEnabled()) loadScriptOnce();
}

export function trackPageview(pathWithSearch) {
  if (!isEnabled()) return;
  loadScriptOnce();
  if (!window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: pathWithSearch,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!isEnabled()) return;
  loadScriptOnce();
  if (!window.gtag) return;
  window.gtag("event", name, params);
}
